import { EVENT_TYPE_FILTER } from '../../../../constants/events'

export const progressInitialState = {
  carSelectionCount: 0, // Подбор авто
  carSelectionCount2: 0, // Выбор авто
  demonstrationCount: 0,
  carChoiceCount: 0,
  carRegistrationCount: 0
}

export const filterInitialState = {
  contactId: '',
  creationType: [],
  dateFrom: null,
  dateTo: null,
  dateType: 'created',
  eventId: '',
  firstName: undefined,
  iin: undefined,
  id: '',
  lastName: undefined,
  managers: [],
  marka: undefined,
  model: undefined,
  oktellStatus: '',
  paymentType: '',
  phoneNumber: undefined,
  ropCheck: false,
  ropCheckFalse: false,
  saleType: '',
  statusCodes: [],
  trade: false,
  vin: undefined,
  seoIdIsNull: undefined
}

export const paginationInitialState = {
  limit: 10,
  offset: 0,
  count: 0
}

export const tasksInitalState = {
  carPriceReconsider: '',
  completed: 'open',
  dealId: undefined,
  endDate: null,
  firstName: undefined,
  phoneNumber: undefined,
  startDate: null,
  statusCodes: EVENT_TYPE_FILTER.map(item => item.code)
}
